import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "../../images/icons/CloseIcon.svg";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": { minHeight: 250 },
  "& .MuiDialogTitle-root img ": {
    filter: "invert(1)",
  },
}));
export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}
export interface DialogContentProps {
  title?: string;
  children?: any;
  windowsize?: any;
  icon?: any;
  show?: any;
  handleShowPopupClick?: any;
  handleHidePopupClick?: any;
  close?: any;
  beta?: any;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 5,
            top: 5,
            color: "#fff",
          }}
        >
          <img src={CloseIcon} alt={"Close"} loading="lazy" />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
export const DialogPopup: React.FC<DialogContentProps> = ({
  title,
  children,
  windowsize,
  icon,
  show,
  handleShowPopupClick,
  handleHidePopupClick,
  close,
  beta,
}) => {
  return (
    <>
      {icon ? (
        <IconButton onClick={handleShowPopupClick}>
          <img src={icon} alt={title} loading="lazy" />
        </IconButton>
      ) : (
        ""
      )}
      <BootstrapDialog
        onClose={handleHidePopupClick}
        aria-labelledby="dialog-title"
        sx={{
          "& .MuiDialogContent-root": {
            padding: title === "Prescription Status" ? 0 : undefined,
          },
        }}
        open={show}
        maxWidth={windowsize}
        fullWidth={true}
      >
        {title ? (
          <>
            <BootstrapDialogTitle
              id="dialog-title"
              onClose={handleHidePopupClick}
            >
              <Typography component={"div"} variant={"body2"}>
                {title} {beta}
              </Typography>
            </BootstrapDialogTitle>
          </>
        ) : (
          ""
        )}

        <DialogContent dividers>
          {close ? (
            <IconButton
              onClick={handleHidePopupClick}
              aria-label="close"
              sx={{
                position: "absolute",
                right: 5,
                top: 5,
                color: "#666666",
                "&:hover": {
                  color: "#fff",
                  "& img": {
                    filter: "invert(1)",
                  },
                },
              }}
            >
              <img src={CloseIcon} alt={"Close"} loading="lazy" />
            </IconButton>
          ) : (
            ""
          )}{" "}
          {children}
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};
